import { useEffect, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Reveal from './Reveal';
import { useLanguage } from '../context/LanguageContext';

function HowItWorksSection() {
  const { t } = useLanguage();
  const stepsPerSlide = 3;
  const slides = useMemo(() => {
    const items = t.howItWorks.steps || [];
    const chunked = [];
    for (let i = 0; i < items.length; i += stepsPerSlide) {
      chunked.push(items.slice(i, i + stepsPerSlide));
    }
    return chunked;
  }, [t.howItWorks.steps]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [isHoverPaused, setIsHoverPaused] = useState(false);

  useEffect(() => {
    if (slides.length <= 1 || isHoverPaused) return undefined;
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length, isHoverPaused]);

  return (
    <section className="section how-it-works">
      <div className="container">
        <Reveal>
          <div className="services-head">
            <span className="eyebrow center">{t.howItWorks.eyebrow}</span>
            <h2>{t.howItWorks.title}</h2>
            <p>{t.howItWorks.subtitle}</p>
          </div>
        </Reveal>
        <div
          className="steps-slider-window"
          onMouseEnter={() => setIsHoverPaused(true)}
          onMouseLeave={() => setIsHoverPaused(false)}
        >
          <div
            className="steps-slider-track"
            style={{ transform: `translateX(-${activeSlide * 100}%)` }}
          >
            {slides.map((group, groupIndex) => (
              <div key={`steps-slide-${groupIndex}`} className="steps-slide">
                <div className="steps-grid">
                  {group.map((step) => (
                    <article
                      key={step.title}
                      className={`step-card${step.image ? ' step-card-image' : ''}`}
                      style={step.image ? { '--step-image': `url(${step.image})` } : undefined}
                    >
                      <div className="step-head">
                        <span className="step-number">{step.number}</span>
                        <span className="material-symbols-outlined step-icon">{step.icon}</span>
                      </div>
                      <h3>{step.title}</h3>
                      <p>{step.text}</p>
                    </article>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <Reveal delay={140}>
          <div className="how-it-works-cta">
            <p>{t.howItWorks.ctaText}</p>
            <NavLink to="/audience#join-application" className="primary-btn">
              {t.howItWorks.ctaButton}
            </NavLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default HowItWorksSection;
